import React from "react";

/**
 * One AI Assist error, shown in exactly one place per task.
 *
 * ``inline`` (task row): a single truncated line with the full sentence in a tooltip, so it
 * can never squeeze the task title. ``banner`` (details panel): full sentence, wraps.
 * Both are dismissible; the owner clears them again on the next run.
 *
 * @example
 * <RunErrorNotice variant="inline" message="We couldn't load the original source for this task. Try again." onDismiss={dismiss} />
 */
const RunErrorNotice = ({ message, onDismiss, variant = "banner" }) => {
  const text = String(message || "").trim();
  if (!text) return null;
  return (
    <div
      className={`run-error-notice run-error-notice--${variant}`}
      role="alert"
      title={text}
      data-testid={`run-error-${variant}`}
    >
      <span className="run-error-notice__text">{text}</span>
      {onDismiss ? (
        <button
          type="button"
          className="run-error-notice__dismiss"
          aria-label="Dismiss error"
          title="Dismiss"
          onClick={(event) => {
            event.stopPropagation();
            onDismiss();
          }}
        >
          ×
        </button>
      ) : null}
    </div>
  );
};

export default RunErrorNotice;
